// extracted by mini-css-extract-plugin
export default {"wrap":"_N-z","articleImagesWrap":"aO-z","articleImage":"bO-z","singleImage":"cO-z"};